var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"ccos-tool"}},[_c('AlertModal',{ref:"alert"}),(_vm.showLayout)?_c('header',{class:[
            'ccos-tool__header',
            {
                'ccos-tool__header--internal': _vm.$store.state.internal,
            } ]},[(!_vm.hideProgress)?_c('ProgressBar'):_vm._e()],1):_vm._e(),_c('section',{staticClass:"ccos-tool__main"},[(_vm.$store.state.loading)?_c('Loader'):_vm._e(),(_vm.showLayout)?_c('div',{staticClass:"ccos-tool__steps",class:{
                'ccos-tool__steps--info': _vm.infoShown,
            },attrs:{"id":"steps"}},[_c('div',{staticClass:"ccos-tool__step"},[_c('router-view')],1)]):_vm._e()],1),(_vm.showLayout)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }